module.exports = __webpack_public_path__ + "static/media/Team 32 - SmartJams.9be43f43.jpg";